module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 486
// module chunks = 0